<template>
    <div class="emboss_deboss_color_custom_box addtext_text_outline_wrap">
        <div class="addtext_font rotation add_font_mobile_w">
            <div class="form-group">
                <div class="range">
                    <!-- eslint-disable -->
                     <label>Text Outline</label><span class="highlight"></span>
                    <input
                        v-model="value"
                        v-on:change="setValue"
                        id="debossValue"
                        type="range"
                        min="1"
                        max="100"
                        class="input_type_rang_custom"
                    />
                    <!-- eslint-enable -->
                </div>
                
            </div>
        </div>

        <div
            :class="
                (mTop === 0 ? 'setwidth_top_margin ' : ' ') +
                'addtext_color font-size_add rot_value add_text_no'
            "
        >
            <div class="form-group">
                <!-- eslint-disable -->
                <input
                    v-on:change="setValue"
                    type="number"
                    v-model="value"
                    id="debossValueInput"
                    required="required"
                    placeholder="1"
                    min="1"
                    max="100"
                    class="range_slider_input span2 form-control bg-whit outline_range"
                />
                <!-- eslint-enable -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Deboss",
    /* eslint-enable */
    props: ["value", "mTop"],
    data: () => {
        return {};
    },
    methods: {
        setValue(e) {
            this.$emit("set-value", Number(e.target.value));
        }
    }
};
</script>

<style></style>
